<template>
  <div class="coupons">
    <header-box />
    <div class="box">
      <p>我的优惠券</p>
      <div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="未使用" name="isused">
            <div class="couponsForm">
              <div class="font" v-if="couponData.length == 0">暂无优惠券</div>
              <div v-for="(item, index) in couponData" :key="index">
                <div class="couponDody">
                  <div class="flexBox">
                    <div style="color: #fff">免费优惠券</div>
                    <div style="color: #fff">
                      <span v-if="item.CouponDto.Type == 2">普通优惠券</span>
                      <span v-else>新人优惠券</span>
                    </div>
                    <div style="color: #fff">{{ item.EndTime }}</div>
                  </div>
                  <div class="position">
                    <div>
                      <router-link to="OnlineInvoicing">
                        <el-button
                          type="warning"
                          plain
                          style="padding: 5px; font-size: 0.8rem"
                          >立即使用</el-button
                        >
                      </router-link>
                    </div>
                    <div>
                      <el-button
                        type="warning"
                        plain
                        @click="ToView(item)"
                        style="padding: 5px; font-size: 0.8rem"
                        >查看使用条件</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="已使用" name="used">
            <div class="couponsForm">
              <div class="font" v-if="couponData.length == 0">暂无优惠券</div>
              <div v-for="(item, index) in couponData" :key="index">
                <div class="couponDody">
                  <div class="flexBox">
                    <div style="color: #fff">免费优惠券</div>
                    <div style="color: #fff">
                      <span v-if="item.CouponDto.Type == 2">普通优惠券</span>
                      <span v-else>新人优惠券</span>
                    </div>
                    <div style="color: #fff">{{ item.EndTime }}</div>
                  </div>
                  <div class="position">
                    <div>
                      <router-link to="OnlineInvoicing">
                        <el-button
                          type="warning"
                          plain
                          style="padding: 5px; font-size: 0.8rem"
                          >立即使用</el-button
                        >
                      </router-link>
                    </div>
                    <div>
                      <el-button
                        type="warning"
                        plain
                        @click="ToView(item)"
                        style="padding: 5px; font-size: 0.8rem"
                        >查看使用条件</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="已过期" name="isexpire">
            <div class="couponsForm">
              <div class="font" v-if="couponData.length == 0">暂无优惠券</div>
              <div v-for="(item, index) in couponData" :key="index">
                <div class="couponDody">
                  <div class="flexBox">
                    <div style="color: #fff">免费优惠券</div>
                    <div style="color: #fff">
                      <span v-if="item.CouponDto.Type == 2">普通优惠券</span>
                      <span v-else>新人优惠券</span>
                    </div>
                    <div style="color: #fff">{{ item.EndTime }}</div>
                  </div>
                  <div class="position">
                    <div>
                      <router-link to="OnlineInvoicing">
                        <el-button
                          type="warning"
                          plain
                          style="padding: 5px; font-size: 0.8rem"
                          >立即使用</el-button
                        >
                      </router-link>
                    </div>
                    <div>
                      <el-button
                        type="warning"
                        plain
                        @click="ToView(item)"
                        style="padding: 5px; font-size: 0.8rem"
                        >查看使用条件</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div style="height: 40vh">
        <div v-for="(item, index) in tipsList" :key="index">
          {{ index + 1 }}.{{ item.label }}:{{ item.value }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import headerBox from "../../components/box/headerbox.vue";
import { getOrderApi } from "../../api/http/order";
export default {
  components: {
    headerBox,
  },
  data() {
    return {
      centerDialogVisible: false,
      activeName: "isused",
      couponData: [],
      tipsList: [
        {
          label: "阻焊颜色",
          value: "绿色",
        },
        {
          label: "字符颜色",
          value: "白色/黑色",
        },
        {
          label: "线宽线距",
          value: ">=6mil",
        },
        {
          label: "最小孔径",
          value: ">=0.3mm",
        },
        {
          label: "表面处理",
          value: "无铅喷锡/有铅喷锡/sop（抗氧化）",
        },
        {
          label: "板材",
          value: "国纪/KB(建滔)，单面样板：FR-4 双面样板：FR-4",
        },
        {
          label: "板厚",
          value: "1.0-1.6mm",
        },
        {
          label: "特殊工艺",
          value: "无",
        },
        {
          label: "单双面板成品外层铜厚",
          value:
            "1oz另外面积限定在0.05平米以内（即长宽尺寸在10*10cm，数量5pcs以内",
        },
        {
          label: "测试方式",
          value: "飞针,目测",
        },
        {
          label: "成型方式",
          value: "铣边",
        },
        {
          label: "发票信息",
          value: "不开发票",
        },
      ],
      params: {
        isexpire: false,
        isused: false,
        page: 1,
        size: 15,
      },
    };
  },
  created() {
    this.couponMylist(this.params);
  },
  methods: {
    ToView(e) {
      if (e.CouponDto.Type == 2) {
        this.$confirm(`满${e.CouponDto.Threshold}减${e.CouponDto.Money}`)
          .then((_) => {
            done();
          })
          .catch((_) => {});
      } else {
        this.centerDialogVisible = true;
      }
    },
    // 请求优惠券
    couponMylist(params) {
      this.couponData = [];
      getOrderApi.getCouponMylist(params).then((res) => {
        this.couponData = res.data.data;
      });
    },
    handleClick(tab, event) {
      if (this.activeName == "isused") {
        this.params = {
          isexpire: false,
          isused: false,
          page: 1,
          size: 20,
        };
      } else if (this.activeName == "used") {
        this.params = {
          isexpire: false,
          isused: true,
          page: 1,
          size: 20,
        };
      } else {
        this.params = {
          isexpire: true,
          page: 1,
          size: 20,
        };
      }
      this.couponMylist(this.params);
    },
  },
};
</script>
<style lang="scss" scoped>
.font {
  font-size: 1.5rem;
  margin: auto;
}
.coupons {
  .flexBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 110px;
    div {
      text-align: center;
    }
  }
  .position {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    div {
      flex: 1;
      text-align: center;
    }
  }
  .couponDody {
    width: 250px;
    margin: 10px;
    background: #eee;
    background-image: url(../../assets/imges/smt-ticket-use.png);
    background-size: 100%;
    background-repeat: no-repeat;
  }
  .couponsForm {
    height: 50vh;
    overflow-y: scroll;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    border: 1px solid #eee;
    margin: auto;
  }
  .box {
    width: 90%;
    margin: auto;
    margin-top: 1rem;
    border: 1px solid #eee;
    .couponsBox {
      display: flex;
      div {
        text-align: center;
        padding: 5px;
        border: 1px solid #999;
        flex: 1;
      }
    }
    p {
      margin-left: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/my/coupons.vue